(function (window) {
    var MDB = window.MDB || {};
    MDB.Snowplow = MDB.Snowplow || {};
    
    var self = document.getElementsByTagName("script"),
        isSecure = true,
        appId = 'MDB',
        scriptVersion='1.0',
        baseUrl = '',
        scriptUrl,
        snowplow;

    for(var i=0;i<self.length;i++) {
        //Support both detection from URL/bundle
        if(self[i].src && (self[i].src.indexOf('/legacy-dnx.js') !== -1 || self[i].src.indexOf('/marketingdb-snowplow.js') !== -1)) {
            // determine base url
            baseUrl = self[i].src;
            var schemaEnd = baseUrl.indexOf('://') + 3;
            baseUrl = baseUrl.substring(schemaEnd, baseUrl.indexOf('/', schemaEnd)+1);

		    // find appId if specified
            var tmp = self[i].src.split('?')[1];
            if(tmp) {
                tmp = tmp.split('&');
                tmp.forEach(function(part) {
                    if(part.indexOf('appId') === 0) {
                        appId = part.split('=')[1] || appId;
                    } else if (part.indexOf('v=') === 0) {
					    scriptVersion = part.split('=')[1] || scriptVersion;
                    }
                });					
            }
        }
    }
    isSecure = baseUrl.indexOf('localhost') === -1;
    scriptUrl = (isSecure ? 'https://' : 'http://') + baseUrl + "Scripts/plowing.js";
    if (scriptVersion) {
        scriptUrl += '?v=' + scriptVersion; 
    }
    //scriptUrl = 'https://d1fc8wv8zag5ca.cloudfront.net/2.7.0/sp.js';

    (function (p, l, o, w, i, n, g) {
        if (!p[i]) {
            p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || [];
            p.GlobalSnowplowNamespace.push(i); p[i] = function () {
                (p[i].q = p[i].q || []).push(arguments);
            }; p[i].q = p[i].q || []; n = l.createElement(o); g = l.getElementsByTagName(o)[0]; n.async = 1;
            n.src = w; g.parentNode.insertBefore(n, g);
        }
    }(window, document, "script", scriptUrl, "snowplow"));

    snowplow = window.snowplow;
    snowplow('newTracker', 'TrackQ', baseUrl + 'Snowplow/newevent', {
        appId: appId,
        forceSecureTracker: isSecure,
        platform: 'web',
        discoverRootDomain: true,
  		userFingerprint: true,
        post: true,
        bufferSize: 5,
        //bufferSize: 2,
  		maxPostBytes: 45000,
  		crossDomainLinker: function (linkElement) {
    		return (linkElement.href === "https://leadq30.leadq.nl"); 
    		//return (linkElement.href === "http://acme.de" || linkElement.id === "crossDomainLink"); 
  		},
        contexts: {
            webPage: true,
		    performanceTiming: true,
		    gaCookies: true,
		    geolocation: false
        }
    });
    
    function getSnowplowDuid(cookieName) {
        cookieName = cookieName || '_sp_';
        var matcher = new RegExp(cookieName + 'id\\.[a-f0-9]+=([^;]+);?');
        var match = document.cookie.match(matcher);
        if (match && match[1]) {
            return match[1].split('.')[0];
        } else {
            return false;
        }
    }
    
    function trimStart(str){
    	if(str){
    		return str.replace(/^\s+/, '');
        }
    	
    	return str;
    }

    function readCookiesAsObject(names){
        var obj = {};

        document.cookie.split(';').forEach(function(cookie){
            cookie = trimStart(cookie);
			
            var nameValuePair = cookie.split('=');
            if(nameValuePair.length !== 2){
                return;
            }

            var name = nameValuePair[0];

            if(names.indexOf(name) !== -1){
                obj[name] = decodeURIComponent(nameValuePair[1]);
            }
        });
		
        return obj;
    }

    if (typeof (MDB) !== 'undefined' && MDB.CurrentUser) {
        var oldMdbUserId = getSnowplowDuid();
        snowplow('setUserId', MDB.CurrentUser.Id);
        if (!oldMdbUserId || oldMdbUserId != MDB.CurrentUser.Id) {
            console.log('Set userid: ' + MDB.CurrentUser.Id, oldMdbUserId);
            snowplow('trackSelfDescribingEvent', {
                schema: "iglu:nl.datanext.dnx/userinfo/jsonschema/1-0-0",
                data: MDB.CurrentUser
            });
        }
    }
    snowplow('enableErrorTracking'); //	 <!-- 2.7.0 and above
    snowplow('enableActivityTracking', 30, 10);
    snowplow('enableFormTracking');	
    snowplow('enableLinkClickTracking');	
    snowplow('trackPageView', /* no custom title */ null, /*  custom event data: */ [{
	    schema: "iglu:nl.datanext.dnx/userinfo/jsonschema/1-0-0",
	    data: (typeof(MDB) === 'undefined' ? {} : MDB.CurrentUser) || {}
    }, {
        schema: 'iglu:nl.datanext.dnx/ga/jsonschema/1-0-0',
        data: readCookiesAsObject(['_ga', '_gid', '_utma', '_utmz'])
    }]);
	

    setTimeout(function __flushbfr() { 
    		snowplow("flushBuffer"); 
    		setTimeout(__flushbfr, 2500);
    }, 1000);
    
    //https://github.com/snowplow/snowplow/wiki/2-Specific-event-tracking-with-the-Javascript-tracker#custom-structured-events
    MDB.Snowplow.trackStructuredEvent = function(category, action, label, property, value){
        if(!category || !action){
            console.warn('Both a category and action are required by snowplow');
            return;
        }
        
        snowplow('trackStructEvent', category, action, label, property, value);
    };
    
    MDB.Snowplow.trackSelfDescribingEvent = function(schema, data){
        //"iglu:nl.datanext.dnx/userinfo/jsonschema/1-0-0"
        
        if(!schema || !data){
            console.warn('Both a schema, and data are required for self describing events');
            return;
        }
        
        snowplow('trackSelfDescribingEvent', {
            schema: schema,
            data: data
        })  
    }
})(window);